export default {
  error: 'error',
  clear: 'clear'
};